<div class="expage">
  <div id="part7" style="text-align:left;">
    <div class="bold blue leftcontainer mediumheight">
      <p class="lefttext textdown">7. {{strings['ROLLING_STOCK_SHORT']}}</p>
    </div>
    <div class="fullborder rightcontainer mediumheight" style="text-align:center;width:15cm;">
      <p>{{strings['DESCRIPTION']}}</p>
    </div>
    <div class="fullborder rightcontainer mediumheight" style="text-align:center;width:9.89cm;border-left:none;">
      <p>{{strings['NOTES']}}</p>
    </div>

    <div style="clear:both;"></div>



    @for (line of engine_lines; track line) {
      <div>
        <div class="leftcontainer smallerheight"></div>
        <div class="fullborder rightcontainer smallerheight" style="width:15cm;border-top:none;">
          <p class="Xengineline textdownhalf lefttext" id="XengineDescription1">
            @if (holder.engines[line]!=null) {
              <span>
                <b>{{holder.engines[line].engine}}</b> | {{strings['VALIDFROM']}} {{dateFormatter.dateToStr(holder.engines[line].valid_from, 'ddmmyyyy')}}
              </span>
            }
          </p>
        </div>
        <div class="fullborder rightcontainer smallerheight" style="width:9.89cm;border-left:none;border-top:none;">
          <p class="Xengineline textdownhalf lefttext" id="XengineRemark1">@if (holder.engines[line]!= null) {
            <span>{{holder.engines[line]['note']}}</span>
          }</p>
        </div>
        <div style="clear:both;"></div>
      </div>
    }

    <div class="smalljump"></div>

    <div id="part8">
      <div class="bold blue leftcontainer mediumheight">
        <p class="lefttext textdown">8. {{strings['INFRASTRUCTURE']}}</p>
      </div>
      <div class="fullborder rightcontainer mediumheight" style="text-align:center;width:15cm;">
        <p>{{strings['DESCRIPTION']}}</p>
      </div>
      <div class="fullborder rightcontainer mediumheight" style="text-align:center;width:9.89cm;border-left:none;">
        <p>{{strings['NOTES']}}</p>
      </div>

      <div style="clear:both;"></div>

      @for (line of infrastructure_lines; track line) {
        <div>
          <div class="leftcontainer smallerheight"></div>
          <div class="fullborder rightcontainer smallerheight" style="width:15cm;border-top:none;">
            @if (all_infrastructures()[line]!=null) {
              <p class="Xinfraline textdownhalf lefttext">
                <b>{{all_infrastructures()[line]['name']}}</b> | {{strings['VALIDFROM']}} {{dateFormatter.dateToStr(all_infrastructures()[line]['valid_from'], 'ddmmyyyy')}}
              </p>
            }
          </div>
          <div class="fullborder rightcontainer smallerheight" style="width:9.89cm;border-left:none;border-top:none;">
            <p class="Xinfraline textdownhalf lefttext">@if (all_infrastructures()[line]!=null) {
              <span>{{all_infrastructures()[line]['note']}}</span>
            }</p>
          </div>
          <div style="clear:both;"></div>
        </div>
      }
    </div>
  </div>